import { useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Typography } from '@mui/material'
import { useApartmentsUnderZoneHead } from '../../assets/api/useAdminApi';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import CustomPagination from '../../shared/utils/CustomPagination';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import StudentCourseTable from '../commonfile/StudentCourseTable';
import { useDialog } from '../../shared/hook/useDialog';

export const ZoneManagerApartmentListTable = ({ id }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: apartmentList, isLoading } = useApartmentsUnderZoneHead({ user_id: id })
      const [selectedRow, setSelectedRow] = useState({});
    const apartmentRow = apartmentList?.apartments?.map((item, index) => ({
        sr_no: index + 1,
        id: index + 1,
        ...item
    })) || []
    const apartmentColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "cluster_name",
            headerName: "Cluster Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "zone_name",
            headerName: "Zone Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "city_name",
            headerName: "City Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "state_name",
            headerName: "State Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "country_name",
            headerName: "Country Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },


    ]
    const viewApartment = (row) => {
        setSelectedRow(row)
        handleClickOpen()
    };
    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={apartmentRow}
                    columns={apartmentColumn}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    onRowClick={(params) => viewApartment(params.row)}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={apartmentRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}

            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
                <Typography variant='h5' mb={1}>Course List</Typography>
                <StudentCourseTable id={selectedRow?.id} />
            </MainDialogBox>
        </>
    )
}
